/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FundSummaryDefinition = {
  readonly id?: number;
  name: string;
  visibility?: FundSummaryDefinition.visibility;
  spreadsheet_definition?: any;
  view_kind?: FundSummaryDefinition.view_kind;
  dashboard_definition?: any;
  readonly created_by?: number | null;
  readonly created_at?: string;
  readonly updated_at?: string;
  cloned_from?: number | null;
  readonly firm?: number;
  readonly fund?: number;
};
export namespace FundSummaryDefinition {
  export enum visibility {
    USER = 'user',
    FIRM = 'firm',
    SCALAR = 'scalar',
    PUBLIC = 'public',
  }
  export enum view_kind {
    SPREADSHEET = 'spreadsheet',
    DASHBOARD = 'dashboard',
  }
}
